import styled from "@emotion/styled";
import { ListItemAvatar } from "@material-ui/core";
// @ts-expect-error
import units from "design-units";

export const UserListContainer = styled.div`
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  margin-left: 1rem;
  position: absolute;
  width: 100%;
  max-width: 350px;
  z-index: 10;
  ${units({
    backgroundColor: "white",
  })};

  .MuiTypography-displayBlock {
    font-size: inherit;
    font-family: inherit;
  }
  .MuiDivider-inset {
    margin: 0;
  }
`;

export const UserListItem = styled.div`
  align-items: center;
  border-bottom: 1px solid;
  cursor: pointer;
  display: flex;
  padding: 1rem;
  ${units({
    borderColor: "lightGrey",
  })};
  &:hover {
    ${units({
      backgroundColor: "lighterGrey",
    })};
  }
`;

export const UserAvatar = styled(ListItemAvatar)`
  margin-right: 1rem;
  min-width: 0;
`;

export const UserName = styled.div`
  display: inline-block;
  margin: 0 1rem 0 0;
`;
